import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    notes: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_NOTE_SELECT_IDS (store, ids) {
      store.notes.selectIds = ids
    },
    REMOVE_NOTE_SELECT_IDS (store, ids) {
      store.notes.selectIds = store.notes.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_NOTE_SELECT_ID (store, id) {
      store.notes.selectId = id
    },
    SET_NOTE_FILTERS (store, filters) {
      store.notes.filters = filters
    },
    SET_NOTE_PAGINATE (store, val) {
      store.notes.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getNotes: (store, getters) => {
      return store.notes.selectIds.map((id) => {
        return getters['entities/notes/find'](id)
      })
    },
    getNotesFilters: (store, getters) => {
      return store.notes.filters
    },
    getNotesPaginate: (store, getters) => {
      return store.notes.paginate
    },
    getNote: (store, getters) => {
      return getters['entities/notes/find'](store.notes.selectId) || {}
    }
  },
  actions: {
    /*
    selectNotes
    */
    selectNotes ({commit, dispatch, getters, state}, filters) {
      return dispatch('getNotes', filters)
      .then((response) => {
        commit('SET_NOTE_FILTERS', filters)
        commit('SET_NOTE_PAGINATE', response)
        commit('SET_NOTE_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectNotes
    */
    refreshSelectNotes ({commit, dispatch, getters, state}) {
      return dispatch('selectNotes', getters.getNotesFilters)
    },
    /*
    selectNote
    */
    selectNote ({commit, dispatch, getters, state}, id) {
      return dispatch('getNoteById', id)
      .then((response) => {
        commit('SET_NOTE_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getNotes
    */
    getNotes ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/notes`, {params: filters})
      .then((response) => {
        return dispatch('entities/notes/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.notes || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getNoteById
    */
    getNoteById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/notes/${id}`)
      .then((response) => {
        return dispatch('entities/notes/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.notes[0]
      })
    },
    /*
    createNote
    */
    createNote ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/notes`, data)
      .then((response) => {
        return dispatch('entities/notes/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.notes[0]
      })
    },
    /*
    updateNote
    */
    updateNote ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/notes/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/notes/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.notes[0]
      })
    },
    /*
    deleteNote
    */
    deleteNote ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/notes/${id}`)
      .then((response) => {
        commit('REMOVE_NOTE_SELECT_IDS', [id])
        dispatch('entities/notes/delete', id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Note.js